import { RouteParams } from '@/router/type';
import { useParams } from 'react-router-dom';
import ChangeName from './components/change-name';
import DeleteProject from './components/delete-project';

const ServerlessByProjectSetting = () => {
  const { projectId } = useParams<RouteParams>();
  return (
    <div className="space-y-8 container mt-8">
      <div>
        <h3 className="text-lg font-medium">General</h3>
        <div className="mt-4">
          <ChangeName />
        </div>
      </div>
      <hr />
      <div>
        <h3 className="text-lg font-medium">Danger Zone</h3>
        <div className="mt-4 flex items-center justify-between rounded-lg border border-destructive/25 p-4">
          <div className="space-y-1">
            <p className="font-semibold">Delete this project</p>
            <p className="text-sm text-muted-foreground">
              Once you delete a project, there is no going back. Please be
              certain.
            </p>
          </div>
          <DeleteProject projectId={projectId!} />
        </div>
      </div>
    </div>
  );
};

export default ServerlessByProjectSetting;
